import type { ReactNode } from 'react';

export const symbol_toll: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M373-253q-93-93-93-227t93-227q93-93 227-93t227 93q93 93 93 227t-93 227q-93 93-227 93t-227-93Zm-113 74q-99-26-159.5-110.5T40-480q0-106 60.5-190.5T260-781q14-4 24 4.5t10 23.5q0 9-6.5 17T272-725q-78 23-125 91.5T100-480q0 85 47 153.5T272-235q9 3 15.5 10.5T294-207q0 15-10 23.5t-24 4.5Zm340-301Zm183.5 183.5Q860-373 860-480t-76.5-183.5Q707-740 600-740t-183.5 76.5Q340-587 340-480t76.5 183.5Q493-220 600-220t183.5-76.5Z"
		/>
	</svg>
);
